import apiV2 from '../api/v2';

// One shared fetch backing three Accounts Overview cards, driven by a
// single granularity toggle (see AccountsOverview.tsx). Entry-based counts.
export type CommunicationsInsightsGranularity = 'day' | 'week' | 'month';

export interface CommunicationsInsightsSeriesPoint {
    bucket: string;
    incoming: number;
    outgoing: number;
    total: number;
}

export interface CommunicationsInsightsTopPractice {
    practiceId: string;
    practiceName: string;
    count: number;
}

export interface CommunicationsInsightsUser {
    userId: string | null;
    fullname: string;
    count: number;
}

export interface CommunicationsInsights {
    granularity: CommunicationsInsightsGranularity;
    windowDays: number;
    series: CommunicationsInsightsSeriesPoint[];
    topPractices: CommunicationsInsightsTopPractice[];
    byUser: CommunicationsInsightsUser[];
}

// Mirrors the server's fixed per-granularity window, without a round trip.
export function communicationsInsightsWindowLabel(
    granularity: CommunicationsInsightsGranularity
): string {
    switch (granularity) {
        case 'week':
            return 'Last 12 weeks';
        case 'month':
            return 'Last 12 months';
        default:
            return 'Last 30 days';
    }
}

export async function fetchCommunicationsInsights(
    granularity: CommunicationsInsightsGranularity
): Promise<CommunicationsInsights> {
    const response = await apiV2.get<{ success: true; data: CommunicationsInsights }>(
        '/practices/communications/insights',
        { params: { granularity } }
    );
    return response.data.data;
}
